import Vue from "vue";

const AlertService = {
    makeToast(variant = null, title, body, autoHideDelay = 10000, toaster="b-toaster-top-center") {
        const vm = new Vue();
        vm.$bvToast.toast(body, {
            title: title,
            variant: variant,
            solid: false,
            autoHideDelay: autoHideDelay,
            toaster: toaster
        });
    }
};

export default AlertService;

